"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import { useAgent } from "../../../../utils/agent/AgentProvider.js";
import { useRef, useEffect } from "react";
import { Box } from "@mui/material";
import { useAuth } from "../../../../hooks/auth/useAuth/index.js";
import { ListsUI } from "./components/ListsUI.js";
import { ShowNotification } from "./components/Notifications/ShowNotification.js";
import { ProductUI } from "./components/ProductUI.js";
import { focusIntoRef, fetchWishList } from "./lib.js";
const SaveToList = (props) => {
  const {
    dispatch,
    enableModernApis,
    locale,
    msStore,
    product,
    setShowSticky,
    showSticky,
    siteValue,
    state
  } = props;
  const {
    successMsg,
    errorMsg,
    globalErrorMsg,
    globalSuccessMsg,
    wishListFetched
  } = state;
  const { agent } = useAgent();
  const { getToken, isLoading: isAuthLoading } = useAuth();
  const notificationRef = useRef(null);
  const { quantity } = state;
  const checkListHeight = () => {
    const muiDrawer = document.querySelector(".MuiDrawer-paper");
    if (!muiDrawer) return;
    const muiChild = muiDrawer.children[0];
    if (!muiChild) return;
    if ((muiChild == null ? void 0 : muiChild.scrollHeight) > (muiChild == null ? void 0 : muiChild.clientHeight)) {
      setShowSticky(true);
    } else {
      setShowSticky(false);
    }
  };
  useEffect(() => {
    if (globalErrorMsg || globalSuccessMsg) {
      checkListHeight();
    }
    if (errorMsg || successMsg) {
      checkListHeight();
      focusIntoRef(notificationRef);
    }
  }, [globalErrorMsg, globalSuccessMsg, errorMsg, successMsg, quantity]);
  useEffect(() => {
    if (wishListFetched) return;
    if (agent && !isAuthLoading) {
      fetchWishList({
        dispatch,
        enableModernApis,
        siteValue,
        state,
        msStore,
        agent,
        getToken
      });
    }
  }, [agent, isAuthLoading]);
  return /* @__PURE__ */ jsxs(Box, { id: "save-to-list-container", children: [
    /* @__PURE__ */ jsx("span", { "aria-live": "polite", ref: notificationRef, tabIndex: -1, children: /* @__PURE__ */ jsx(ShowNotification, { errorMsg, successMsg }) }),
    /* @__PURE__ */ jsx(
      ProductUI,
      {
        dispatch,
        msStore,
        product,
        state
      }
    ),
    /* @__PURE__ */ jsx(
      ListsUI,
      {
        checkListHeight,
        enableModernApis,
        locale,
        dispatch,
        msStore,
        product,
        showSticky,
        siteValue,
        state
      }
    )
  ] });
};
export {
  SaveToList
};
